export const appLinks = {
  privacyLink: 'https://www.purpleocean.co/privacy'
};

const Const = {
  personalizedReading: {
    loading: 'personalizedReading:loading',
    loaded: 'personalizedReading:loaded',
    questionsLoaded: 'personalizedReading:questionsLoaded'
  },
  aboutMe: {
    loading:'aboutMe:loading',
    loaded: 'aboutMe:loaded'
  },
  payments: {
    loading: 'payments:loading',
    loaded: 'payments:loaded',
    paymentProcessing: 'payments:paymentProcessing',
    setPaymentsParams: 'payments:setPaymentsParams',
    setPaymentsData: 'payments:setPaymentsData',
    setPaymentsResponce: 'payments:setPaymentsResponce',
    clearPaymentsParams: 'payments:clearPaymentsParams',
    setPaymentsCardData: 'payments:setPaymentsCardData'
  },
  order: {
    save: 'order:save',
    clearOrderKey: 'order:clearOrderKey'
  },
  application: {
    error: 'application:error',
    clearError: 'application:clearError'
  },
  user: {
    loading: 'user:loading',
    loaded: 'user:loaded',
    error: 'user:error',
    emailValidated: 'user:emailValidated',
    emailValidationError: 'user:emailValidationError',
    emailValidationErrorClear: 'user:emailValidationErrorClear',
    emailError: 'user.emailError',
    MPIdentify: 'user.MPIdentify'
  },
  orderView: {
    loading: 'order:loading',
    loaded: 'order:loaded',
    error: 'order:error',
    viewed: 'order:viewed'
  },
  navigation: {
    initialScreen: 'navigation:initialScreen',
    updateCurrentScreen: 'navigation:updateCurrentScreen',
    backAction: 'navigation:backAction'
  },
  paymentSources: {
    load: 'paymentSources:load',
    loaded: 'paymentSources:loaded',
    edit: 'paymentSources:edit',
    done: 'paymentSources:done',
    manage: 'paymentSources:manage',
    addingCardData: 'paymentSources:addingCardData',
    addingCardError: 'paymentSources:addingCardError',
    clearAddingCardError: 'paymentSources:clearAddingCardError',
    doneAddCard: 'paymentSources:doneAddCard'
  },
  paymentOptions: {
    load: 'paymentOptions:load',
    loaded: 'paymentOptions:loaded',
    reset: 'paymentOptions:reset'
  },
  purchaseDetails: {
    updateDetails: 'purchaseDetails:updateDetails',
    changingPaymentSource: 'purchaseDetails:changingPaymentSource',
    clearDetails: 'purchaseDetails:clearDetails'
  },
  messageToApp: {
    setData: 'messageToApp:setData'
  },
  creditCardProcessing: {
    loading: 'creditCardProcessing:loading',
    dataLoaded: 'creditCardProcessing:dataLoaded',
    purchaseLoaded: 'creditCardProcessing:purchaseLoaded',
    purchaseResponceLoaded: 'creditCardProcessing:purchaseResponceLoaded',
    clearCreditCardProcessing: 'creditCardProcessing:clearCreditCardProcessing',
    error: 'creditCardProcessing:error'
  },
  purchaseDetailsModal: {
    setModalIsShown: 'purchaseDetailsModal:setModalIsShown',
    setPriceAndBonus: 'purchaseDetailsModal:setPriceAndBonus'
  }
};

export default Const;
